import { render, staticRenderFns } from "./Collapses.vue?vue&type=template&id=47bf3d22&"
import script from "./Collapses.vue?vue&type=script&lang=js&"
export * from "./Collapses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\yuichi\\git\\open_coupon\\public\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47bf3d22')) {
      api.createRecord('47bf3d22', component.options)
    } else {
      api.reload('47bf3d22', component.options)
    }
    module.hot.accept("./Collapses.vue?vue&type=template&id=47bf3d22&", function () {
      api.rerender('47bf3d22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/base/Collapses.vue"
export default component.exports